<template>
  <div v-if="templates && templates.length > 0" class="message-templates">
    <v-select
      v-if="theme === 'v-select'"
      class="message-templates--select"
      v-model="selectedTemplate"
      :options="templates"
      :placeholder="formattedPlaceholder"
    >
      <template #search="{ attributes, events }">
        <input class="vs__search" v-bind="attributes" v-on="events" />
      </template>
    </v-select>

    <b-dropdown
      v-else-if="theme === 'dropdown'"
      class="message-templates--dropdown border"
      size="sm"
      :variant="isDarkMode ? 'dark' : 'light'"
    >
      <template #button-content>
        {{ selectedTemplate ? selectTemplate.label : formattedPlaceholder }}
      </template>
      <b-dropdown-item
        v-for="option in templates"
        :key="option.value"
        @click="selectTemplate(option)"
      >{{ option.label }}</b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "../../events/eventBus";
import MessagePreview from "./MessagePreview";
import vSelect from "vue-select";

export default {
  name: "MessageTemplates",
  components: { vSelect },
  props: {
    theme: {
      type: String,
      default: "v-select",
    },
    placeholder: {
      type: String,
      default: "Send Quick Reply Template",
    },
    noItemPlaceholder: {
      type: String,
      default: "No Reply Templates Found",
    }
  },
  computed: {
    ...mapGetters("agency", ["currentAgencyId"]),
    ...mapGetters("user", ["currentToken", "isDarkMode"]),
    ...mapGetters("conversations", ["conversationStatus"]),
    formattedPlaceholder() {
      if (this.isLoading === true)
        return "Loading...";
      else
        return this.templates.length === 0 ? this.noItemPlaceholder : this.placeholder ;
    }
  },
  data() {
    return {
      templates: [],
      selectedTemplate: null,
      isLoading: false,
    };
  },
  created() {
    this.fetchTemplates();
  },
  methods: {
    populateMessage(label, txt) {
      const $ = window.$;
      $("#id-modal-container").modal();
      EventBus.$emit("open", {
        component: MessagePreview,
        title: label,
        props: {
          message: String(txt).trim()
        },
        closeOnClick: false
      });
    },
    async fetchTemplates() {
      this.isLoading = true;
      const resp = await this.$ConveyApi.templatesApi.getUserMessageTemplates({
        params: { templateType: "all" }
      });
      this.templates = resp.data.data.map(t => ({ label: t.name, value: t.template_id, text: t.text }));
      this.isLoading = false;
    },
    selectTemplate(template) {
      this.selectedTemplate = template;
    }
  },
  watch: {
    selectedTemplate: {
      handler(template) {
        if (template) {
          this.populateMessage(template.label, template.text);
          this.selectedTemplate = null;
        }
      },
      deep: true,
    }
  },
};
</script>

<style scoped>
@import '../../../node_modules/vue-select/dist/vue-select.css';

p {
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 15px;
  height: calc(100vh - 300px);
}
</style>

<style lang="scss">
.message-templates {
  width: 100%;
  &--select {}
  &--dropdown {
    border-radius: 1rem;
    >button {
      @media screen and (max-width: 767px) {
        font-size: 12px;
      }
    }

    .dropdown-menu {
      max-height: 240px;
      overflow-y: auto;

      @media screen and (max-width: 767px) {
        font-size: 12px;
      }
    }
  }
}
</style>
